import React, { useEffect } from "react";
import OverlayContainer from "./OverlayContainer";

const AlertOverlay = ({
  stat,
  title,
  message,
  onClose,
  onConfirm,
  confirmText = "OK",
  cancelText,
  className = "",
  autoCloseMs,
}) => {
  useEffect(() => {
    if (!stat) return;
    if (!autoCloseMs) return;
    const timer = setTimeout(() => {
      if (typeof onClose === "function") onClose();
    }, autoCloseMs);
    return () => clearTimeout(timer);
  }, [stat, autoCloseMs, onClose]);

  const handleConfirm = async () => {
    if (typeof onConfirm === "function") {
      await onConfirm();
    }
    if (typeof onClose === "function") onClose();
  };

  return (
    <OverlayContainer
      className={`alert-overlay ${className}`}
      stat={stat}
      toggleOverlay={onClose}
      contentWidth="420px"
      contentHeight="fit-content"
      noExitBtn
    >
      <div className="alert-content">
        {title && <p className="alert-title">{title}</p>}
        {message && <p className="alert-message">{message}</p>}
        <div className="alert-actions">
          {cancelText && (
            <div className="action-button alert-secondary" onClick={onClose}>
              <p className="btn grey small-text">{cancelText}</p>
            </div>
          )}
          <div className="action-button bg-orange" onClick={handleConfirm}>
            <p className="btn">{confirmText}</p>
          </div>
        </div>
      </div>
    </OverlayContainer>
  );
};

export default AlertOverlay;
